import React, { useState } from "react";
import QuadratinoColore from "./QuadratinoColore";

function AreaInputColore(props) {
        
    //const prodottoTemp=props.prodottoTemp; 
    const colori=props.colori;
    const datoId=props.datoId;
    const inputLabel=props.inputLabel;
    const col1 = props.col1;
    const col2 = props.col2;
    const col3 = props.col3;
    const colSelChange=props.colSelChange
    const colNonSelChange=props.colNonSelChange

    const [colHover, setColHover] = useState("")

    //console.log(iDcolSel1,iDcolSel1)

    return (
        <div className="mb2 ">
            <label for={datoId}>{inputLabel}</label><br />
            <div className="mt2 measure flex flex-wrap">
                {colori.map((col,i) => <QuadratinoColore 
                colore={col} 
                iDcolSel1={col1.valueId ?? ""} 
                iDcolSel2={col2.valueId ?? ""} 
                iDcolSel3={col3.valueId ?? ""} 
                colSelChange={colSelChange}
                colNonSelChange={colNonSelChange}
                setColHover={setColHover}
                />)}
            </div> 
            {/* <>componente che dice il colore su cui è il mouse al momento</> */}            
            <p>{colHover}</p>
            <h4>Selezionati</h4>
            <p>{col1.valueDesc ?? ""}<br />{col2.valueDesc ?? ""}<br />{col3.valueDesc ?? ""}</p>
            {/* colori.filter(c => c.idPS1 === iDcolSel1 || c.idPS2 === iDcolSel2 || c.idPS3 === iDcolSel3 ).map((col,i) => <p>{col.desc}</p>) */}
        </div>
    )



}

export default AreaInputColore;